import cryptoImage from '../assets/images/expertise-image.jpg';
import aiImage from '../assets/images/artificial-intelligence.png';
import fintechImage from '../assets/images/fintech.png';
import ecommerceImage from '../assets/images/e-commerce.png';
import healthcareImage from '../assets/images/healthcare.png';
import CryptoIcon from '../assets/images/components/CryptoIcon';
import IntelligenceIcon from '../assets/images/components/IntelligenceIcon';
import Fintech from '../assets/images/components/Fintech';
import ECommerce from '../assets/images/components/ECommerce';
import HealthCareIcon from '../assets/images/components/HealthCareIcon';

import crypto from '../assets/images/crypto.png';
export interface ExpertiseCard {
  id: string;
  title: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
  content: string[];
  image: string;
}

export const expertiseCardsData: ExpertiseCard[] = [
  {
    id: 'crypto',
    title: 'Crypto',
    icon: CryptoIcon,
    content: [
      'Assisting crypto exchanges with FIU-IND registration and compliance.',
      'Drafting contracts for exchanges, wallets, and blockchain platforms.',
      'Ensuring AML/KYC compliance and reporting obligations.',
      'Advising on token offerings, stable-coins, and DeFi models',
      'Protecting crypto IP, trademarks, and technology assets.',
      'Guiding cross-border operations and global regulatory compliance',
    ],
    image: crypto,
  },
  {
    id: 'ai',
    title: 'Artificial Intelligence',
    icon: IntelligenceIcon,
    content: [
      'Drafting Al software, SaaS, and licensing contracts',
      'Ensuring compliance with Al and data laws.',
      'Setting up privacy and cyber security frameworks.',
      'IP protection for Al products & lawful dataset use',
      'Sector-focused advisory: fin-tech, health-tech and e-commerce',
    ],
    image: aiImage,
  },
  {
    id: 'fintech',
    title: 'Fintech',
    icon: Fintech,
    content: [
      'Structuring from startup to IPО, including M&A and fundraising',
      'Regulatory counsel & licensing for financial services',
      'Advisory on payments, lending, BNPL & digital assets (crypto, DeFi)',
      'Legal support for insurtech, prop-tech and emerging fintech models',
      'IP protection & data privacy compliance',
    ],
    image: fintechImage,
  },
  {
    id: 'ecommerce',
    title: 'E-commerce',
    icon: ECommerce,
    content: [
      'Drafting website terms, privacy policies & consumer facing contracts',
      'Compliance with e-commerce laws, IT Act & consumer protection rules',
      'Data privacy, cybersecurity and DPDP/GDPR alignment',
      'IP protection & enforcement for online brands',
      'Legal support for payment systems & fintech integrations',
    ],
    image: ecommerceImage,
  },
  {
    id: 'healthcare',
    title: 'Healthcare',
    icon: HealthCareIcon,
    content: [
      'Structuring ventures, M&A, investments & strategic collaborations',
      'Compliance for drugs, devices, clinical trials & digital health',
      'Data privacy, cybersecurity & HIPAА/ global health data compliance',
      'Regulatory approvals, licensing & product registration',
      'Advising on token offerings, stable coins, and DeFi models',
      'IP protection & key contract support (tech, supply chain, distribution)',
    ],
    image: healthcareImage,
  },
];
